import { render, staticRenderFns } from "./EncaminhamentoForm.vue?vue&type=template&id=7d64c8f4&"
import script from "./EncaminhamentoForm.vue?vue&type=script&lang=js&"
export * from "./EncaminhamentoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports